import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Input } from 'components/common/FormElements/Input'
import * as UI from './FormStyles'
import { PHONE_MASK } from 'constant'
import { normalizePhoneNumber } from 'helpers/phone-number'

const CellPhoneNumber = ({ form, ...props }) =>
  <React.Fragment>
    <UI.Row>
      <UI.Cell>
        <Field
          { ...props }
          { ...form.primaryPhone }
          mask={ PHONE_MASK }
          full
          static
          normalize={ normalizePhoneNumber }
          component={ Input } />
      </UI.Cell>
    </UI.Row>
  </React.Fragment>

CellPhoneNumber.propTypes = {
  form: PropTypes.shape({
    primaryPhone: PropTypes.shape()
  })
}

export default CellPhoneNumber
